import React, { Component } from "react";
import { Col, Image } from "react-bootstrap";
import * as jalaliMoment from "jalali-moment";
import { currencyFormat } from '../helpers'
import {fileTypes, usageTypes} from "../constants";

class Estate extends Component {
    render() {
        const query = new URLSearchParams(this.props.file);
        query.delete('attachments');
        let file_url = "/estate-detail/" + this.props.file.id  + "?" + query.toString();

        let image_name = [5,6,7].includes(this.props.file.file_type_id) ? 'property.jpg' : 'estate.jpg';

        const file_image = (this.props.file.attachments) && !this.props.file.attachments.includes("default.jpg")?
            this.props.file.attachments :
            process.env.REACT_APP_BASE_URL + "/images/default/" + image_name;

        let current_year = new Date().getFullYear();
        current_year = jalaliMoment(current_year, 'YYYY')
            .locale('fa')
            .format('YYYY');

        let building_age = (this.props.file.building_age === 0)
            ? 0
            : current_year - this.props.file.building_age;

        let file_type = fileTypes[this.props.file.file_type_id] ?? '-';
        let usage_type = usageTypes[this.props.file.usage_type_id] ?? '-';

        return (
            <Col md={6} lg={4}>
                <div className="item mb-50">
                    <div className="img">
                        <Image src={file_image} alt=""/>
                        <a href={file_url} className="add-cart">
                            {building_age} ساله <br/>
                            {this.props.file.total_meters} متر‌مربع <br/>
                            {this.props.file.province} - {this.props.file.city}
                        </a>
                        <span className="fav">
                            کد پرونده : {this.props.file.file_code}
                        </span>
                    </div>
                    <div className="cont">
                        <h6><a href={file_url}> {file_type} {usage_type}</a></h6>
                        <h5><a href={file_url}> قیمت تقریبی کل : {currencyFormat(this.props.file.bank_part_price)} ریال</a></h5>
                    </div>
                </div>
            </Col>
        );
    }
}
export default Estate;
